import Vue from "vue";
import conf from "@/config";

Object.defineProperty(Vue.prototype, '$conf', { value: conf });